import { isEmpty, isNull, isUndefined } from 'lodash'
import React, { useMemo } from 'react'
import { CellRenderers, columnRenderArrayData } from 'utils/tableUtils'
import GenericPullConfigListing from '../GenericPullConfigListing'
import HackerOneCredentialsForm from './HackerOneCredentialsForm'
import HackerOneMappingForm from './HackerOneMappingForm'

export default function HackerOneConfigListing(props) {

    const extraColumns = useMemo(() => [
        {
            dataIndex: "orgName",
            title: 'Organisation',
            width: 120
        }, {
            dataIndex: "applicationName",
            title: 'Project',
            width: 120,
            render: columnRenderArrayData
        },
        {
            dataIndex: "inboxName",
            title: 'Inbox',
            width: 120,
            render: columnRenderArrayData
        }
        , {
            dataIndex: "customFieldMapping",
            title: <>{props.name} Custom Field for URL</>,
            render: (val, record) => {
                const url = JSON.parse(val || "[]")[0]?.url;
                if (isNull(val) || isEmpty(val) || isEmpty(url) || isUndefined(url)) {
                    return CellRenderers.VALUE_OR_NA()
                };
                return url;
            },
            width: 130
        }
    ], [props.name]);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={HackerOneMappingForm}
            CredentialsForm={HackerOneCredentialsForm}
            displayComponentName={"Project"}
            extraColumns={extraColumns}
        />
    )
}